/* global G */
import find from 'lib/sequence/component/children/find'
import { hidden } from 'lib/sequence/component/state/hidden'
import { setKey } from 'lib/util'

/**
 * Initializes the logic surrounding the address form by executing `handlers`.
 *
 * This mimics the `component`'s `onChange` handler, but only with the handlers
 * we need for the address logic (so no `persist` or anything else).
 *
 * @param {ComponentInfo} componentInfo   information about what component to use
 * @param {AttributeInfo} attributeInfo   information about what model to use
 * @returns {function(...function): function(Gaia.AppModule.Spec): function(Object, ...[*]): Promise<*>}
 */
export default (componentInfo, attributeInfo) => (...handlers) => module => async (components, ...args) => {
  const actionState = module[G.STATE][G.ACTION][G.STATE]
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]

  const isInitialized = actionState?.[componentInfo.parent || componentInfo.component]?.initAddress

  const parentComponent = componentInfo.parent
    ? find(actionComponent)[componentInfo.parent]
    : actionComponent
  const { [componentInfo.component]: handlerComponent } = find(parentComponent)

  if (hidden(parentComponent)) {
    return [components, ...args]
  }

  if (attributeInfo && !isInitialized) {
    handlerComponent[G.EVENTS].onChange = await handlerComponent[G.EVENTS].onChange(componentInfo)(attributeInfo)
  }

  if (!isInitialized) {
    for (let i = 0; i < handlers.length; i++) {
      await handlers[i](componentInfo, attributeInfo)(module, handlerComponent, null)
    }
  }

  setKey({ initAddress: true }, componentInfo.parent || componentInfo.component, actionState)

  return [components, ...args]
}
